import { Grid, GridProps, styled } from '@material-ui/core';
import React from 'react';
import colorPalette from '../../themes/colorPalette';
import TextLabel from '../TextLabel';
import Typo from '../Typo';

const { coolGrey, grey } = colorPalette;

export const IconContainerGrid = styled(Grid)({
  display: 'inline-flex',
  verticalAlign: 'middle',
  '& > svg': {
    color: grey[9],
  },
});

export const StyledGrid = styled(Grid)({
  '& > *': {
    wordBreak: 'break-word',
  },
});

const StyledGridContainer = styled(Grid)({
  '& > *': {
    marginRight: '8px',
  },
  '& > *:last-child': {
    marginRight: '0px',
  },
});

export type TextLabelProps = {
  color: string;
  bgcolor: string;
  text: string;
};

export type BannerListItemProps = {
  icon?: React.ReactNode;
  primaryText: string | React.ReactNode;
  secondaryText?: string | React.ReactNode;
  textLabel?: React.ReactNode | TextLabelProps;
  className?: string;
};

function BannerListItem({
  icon,
  primaryText,
  secondaryText,
  textLabel,
  className,
  ...other
}: BannerListItemProps & GridProps) {
  const IconComponent: any = icon;
  const { color, text }: any = textLabel || {};
  const isTextLabelObj = !!(color && text);
  const textLabelObj = textLabel as TextLabelProps;

  return (
    <StyledGridContainer
      container
      item
      alignItems="center"
      wrap="nowrap"
      className={className || ''}
      {...other}
    >
      {textLabel && (
        <StyledGrid item>
          {isTextLabelObj ? (
            <TextLabel
              color={textLabelObj.color}
              bgcolor={textLabelObj.bgcolor || coolGrey[1]}
            >
              {textLabelObj.text}
            </TextLabel>
          ) : (
            textLabel
          )}
        </StyledGrid>
      )}
      {icon && (
        <IconContainerGrid item>
          <IconComponent fontSize="small" />
        </IconContainerGrid>
      )}
      {primaryText && (
        <StyledGrid item>
          <Typo variant="bodySm">{primaryText}</Typo>
        </StyledGrid>
      )}
      {secondaryText && (
        <Grid item>
          <Typo variant="bodySm" color="muted">
            {secondaryText}
          </Typo>
        </Grid>
      )}
    </StyledGridContainer>
  );
}

export default BannerListItem;
